import React, { useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Button, Dialog, DialogContent, Divider, Typography } from '@material-ui/core'
import { useLiterals } from '~/components/Literals'

const styles = (theme) => ({
  root: {
    justifyContent: 'center',
    textAlign: 'center'
  },
  body: {
    padding: 24
  },
  img: {
    display: 'block',
    margin: '0 auto 24px',
    maxHeight: 120,
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'center'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 15
  },
  button: {
    width: '50%',
    height: 41
  },
  buttonNo: {
    borderWidth: 2,
    borderColor: theme.palette.primary.light
  },
  rootBackdrop: { position: 'absolute' }
})

function AgeGate({ ageGateMessage, setShowAgeGate, ageGateRedirect, imageUrl, classes }) {
  const [open, setOpen] = useState(true)
  const [message, setMessage] = useState(false)

  const { getLiteral } = useLiterals()

  function handleCloseNo() {
    if (ageGateRedirect && ageGateRedirect.length > 3) {
      window.location = ageGateRedirect
    } else {
      setMessage(true)
    }
  }

  function handleClose() {
    setOpen(false)
    setShowAgeGate(false)
  }

  return (
    <Dialog
      open={open}
      className={classes.root}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      container={document.getElementById('gofind-finder') || document.body}
      style={{ position: 'absolute' }}
      BackdropProps={{
        classes: { root: classes.rootBackdrop }
      }}
    >
      <DialogContent id="alert-dialog-title" className={classes.body}>
        {imageUrl && <img src={imageUrl} className={classes.img} loading="lazy" />}
        <Typography>{ageGateMessage}</Typography>

        <Divider style={{ margin: '22px 0' }} />

        {message ? (
          <Typography style={{ fontWeight: 700, textAlign: 'center' }}>
            {getLiteral('2399')}
          </Typography>
        ) : (
          <div className={classes.buttonsContainer}>
            <Button
              variant="contained"
              className={classes.button}
              onClick={handleClose}
              color="primary"
            >
              {getLiteral('1843')}
            </Button>
            <Button
              variant="outlined"
              className={`${classes.button} ${classes.buttonNo}`}
              onClick={handleCloseNo}
            >
              {getLiteral('1844')}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default withStyles(styles)(AgeGate)
